<template>
  <b-container class="container-rda">
    <b-row style="width: 100%">
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <b-col>
        <h2 class="purple bold title">
          Alunos <span class="tags_count">{{ count }}</span>
        </h2>
      </b-col>
      <b-col
        md="10"
        lg="10"
        class="d-flex justify-content-end"
        style="gap: 15px"
      >
        <b-button
          v-if="canEdit"
          class="btn blue"
          :disabled="
            !students ||
            !students.length ||
            isLoadingStudentReport ||
            !cycle_select
          "
          @click="downloadStudentReport(null)"
        >
          {{
            !isLoadingStudentReport
              ? "Exportar dados de matrícula"
              : "Carregando..."
          }}
        </b-button>

        <router-link
          v-if="canEdit"
          md="4"
          lg="4"
          class="btn blue"
          :to="{name: 'emitir-carteirinha'}"
          >Emitir carteirinha</router-link
        >
      </b-col>
    </b-row>

    <b-row class="mt-50" style="width: 100%; margin-bottom: 20px">
      <b-col>
        <SelectCalendar
          label="Ano"
          placeholder="Selecione"
          v-model="calendar"
          :callback="callbackCalendars"
          :yearsBack="3"
          :selected="calendar"
        />

        <span
          class="clear-field"
          v-if="this.calendar != null"
          @click="clearCalendar"
          >Limpar filtro</span
        >
      </b-col>
      <b-col>
        <SelectCycles
          v-model="cycle"
          :callback="callbackCycles"
          :selected="cycle_select"
        ></SelectCycles>
        <span class="clear-field" @click="clearCycles">Limpar filtro</span>
      </b-col>
      <b-col>
        <SelectClassrooms
          v-model="classroom"
          :callback="callbackClassrooms"
          :cycle="cycle_select"
          :selected="classroom"
        />
        <span
          class="clear-field"
          v-if="this.classroom != null"
          @click="clearClassromms"
          >Limpar filtro</span
        >
      </b-col>

      <b-col>
        <SelectCycleSituation
          v-model="cycle_situation"
          :callback="callbackCycleSituation"
          :selected="cycle_situation"
        />
        <span
          class="clear-field"
          v-if="this.cycle_situation != null"
          @click="clearCycleSituation"
          >Limpar filtro</span
        >
      </b-col>

      <b-col>
        <SelectStudentsStatus
          v-model="is_active"
          :callback="callbackStudentsStatus"
          :selected="is_active"
        />
        <span
          class="clear-field"
          v-if="this.is_active != null"
          @click="clearStudentsStatus"
          >Limpar filtro</span
        >
      </b-col>

      <b-col style="padding-right: 0">
        <b-form-group label="Buscar aluno">
          <b-form-input
            type="search"
            size="sm"
            placeholder="Digite aqui"
            v-model="search"
            @change="searchStudent"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <b-container fluid style="padding: 0">
          <b-row
            style="margin-left: 0; margin-right: 0;"
            class="header-list-teacher"
            :class="{'floating-header': showFloatingHeader}"
            v-if="wasRequestMade && students.length"
          >
            <b-col
              :md="
                !canEdit
                  ? !isSpecializedEducationalSupport && !isTeacher
                    ? 5
                    : 4
                  : 2
              "
              :class="['text-left']"
            >
              <p class="bold">Nome</p>
            </b-col>
            <b-col
              :md="
                !canEdit
                  ? !isSpecializedEducationalSupport && !isTeacher
                    ? 4
                    : 3
                  : 1
              "
              class="text-center"
            >
              <p class="bold">Ciclo</p>
            </b-col>
            <b-col v-if="canEdit" class="text-center student-status-column">
              <p class="bold">Ativo</p>
            </b-col>
            <b-col
              v-if="canEdit || isSpecializedEducationalSupport || isTeacher"
              class="text-center"
            >
              <p class="bold">Visualizar Info.</p>
            </b-col>
            <b-col class="text-center">
              <p class="bold">Parecer/<wbr />Tutoria</p>
            </b-col>
            <b-col v-if="canEdit" class="text-center">
              <p class="bold">Editar Dados</p>
            </b-col>
            <b-col v-if="canEdit" class="text-center">
              <p class="bold">Editar Senha</p>
            </b-col>

            <b-col v-if="canEdit" class="text-center">
              <p class="bold">Editar Matrícula</p>
            </b-col>

            <b-col v-if="canEdit" class="text-center export-data-column">
              <p class="bold">Exportar Dados</p>
            </b-col>

            <b-col v-if="canEdit" class="text-center">
              <p class="bold">Exportar RDA</p>
            </b-col>
            <b-col v-if="canEdit" class="text-center">
              <p class="bold">Excluir</p>
            </b-col>
          </b-row>

          <b-row
            align-v="center"
            class="list-teacher"
            v-for="student in students"
            :key="student.id"
          >
            <b-col
              :md="
                !canEdit
                  ? !isSpecializedEducationalSupport && !isTeacher
                    ? 5
                    : 4
                  : 2
              "
              :class="['name', 'text-left']"
            >
              <p class>{{ student.user_name }}</p>
            </b-col>

            <b-col
              :md="
                !canEdit
                  ? !isSpecializedEducationalSupport && !isTeacher
                    ? 4
                    : 3
                  : 1
              "
              class="cycles text-center"
            >
              <p
                class="tags"
                :style="
                  student.cycle_name && student.cycle_name.length > 10
                    ? 'font-size: 12px'
                    : 'font-size: 12px'
                "
              >
                {{ student.cycle_name }}
              </p>
            </b-col>

            <b-col v-if="canEdit" class="status text-center student-status-column">
              <b-form-checkbox
                switch
                v-if="student.is_active"
                v-model="student.is_active"
                class="student-status-switch"
                @input="updateStatus(student.id, false)"
              ></b-form-checkbox>
              <b-form-checkbox
                switch
                v-else
                v-model="student.is_active"
                class="student-status-switch"
                @input="updateStatus(student.id, true)"
              ></b-form-checkbox>
            </b-col>

            <b-col
              v-if="canEdit || isSpecializedEducationalSupport || isTeacher"
              class="text-center"
            >
              <router-link
                :to="{
                  name: 'perfil-aluno',
                  params: {id: student.id},
                }"
              >
                <TeacherIcon />
              </router-link>
            </b-col>

            <b-col
              v-if="
                (student.cycle_id && student.cycle_id == 8) ||
                student.cycle_id == 6
              "
              class="text-center"
            >
              <router-link
                :to="{
                  name: isSpecializedEducationalSupport
                    ? 'dashboard-timeline-aluno-parent'
                    : 'dashboard-timeline-aluno',
                  params: {id: student.id},
                }"
              >
                <ViewIcon />
              </router-link>
            </b-col>
            <b-col v-else class="text-center">
              <router-link
                :to="{
                  name: 'dashboard-tutoria-aluno',
                  params: {id: student.id},
                }"
              >
                <ViewIcon />
              </router-link>
            </b-col>

            <b-col v-if="canEdit" class="text-center">
              <a
                @click="() => setStudent(student, student.id)"
                v-b-modal.student-data
              >
                <EditIcon />
              </a>
            </b-col>

            <b-col
              v-if="canEdit"
              class="editar-senha text-center"
            >
              <a
                @click="() => setStudentPassword(student, student.id)"
                v-b-modal.edit-password
              >
                <LockIcon />
              </a>
            </b-col>

            <b-col v-if="canEdit" class="text-center">
              <router-link
                :to="{
                  name: 'dadosMatricula',
                  params: {id: student.id},
                }"
                target="_blank"
              >
                <EditIcon />
              </router-link>
            </b-col>

            <b-col v-if="canEdit" class="text-center export-data-column">
              <a
                @click="downloadStudentReport(student.id, student.cycle_id)"
              >
                <ExportIcon />
              </a>
            </b-col>

            <b-col v-if="canEdit" class="text-center">
              <router-link
                :to="{
                  name: 'exportar-relatorio-desenvolvimento',
                  params: {id: student.id},
                }"
              >
                <ExportIcon />
              </router-link>
            </b-col>

            <b-col v-if="canEdit" class="text-center">
              <a @click="() => confirmStudentDeletion(student.id)">
                <DeleteIcon />
              </a>
            </b-col>
          </b-row>

          <b-row
            align-v="center"
            class="list-teacher"
            v-if="wasRequestMade && !students.length"
          >
            <b-col class="text-center">Nenhum resultado encontrado</b-col>
          </b-row>
          <b-row align-v="center" class="list-teacher" v-if="!wasRequestMade">
            <b-col class="text-center">Carregando</b-col>
          </b-row>
          <b-row class="align-center" v-if="!search && wasRequestMade">
            <b-pagination
              v-model="currentPage"
              :per-page="perPage"
              :total-rows="count"
              aria-controls="teachersList"
              last-text
              first-text
            >
              <template #prev-text>
                <LeftArrowIcon class="left" />
              </template>
              <template #next-text>
                <LeftArrowIcon />
              </template>
            </b-pagination>
          </b-row>

          <StudentEditData :student="studentToEdit" />

          <StudentEditPassword :student="studentToPassword" />
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DataService from "@/services/students.service";
import {mapActions, mapGetters} from "vuex";

import SelectCalendar from "@/components/inputs/SelectCalendar.vue";
import SelectClassrooms from "@/components/inputs/SelectClassrooms.vue";
import SelectCycles from "@/components/inputs/SelectCycles.vue";
import SelectStudentsStatus from "@/components/inputs/SelectStudentsStatus.vue";
import SelectCycleSituation from "@/components/inputs/SelectCycleSituation.vue";
import StudentEditData from "@/components/modals/StudentEditData.vue";
import StudentEditPassword from "@/components/modals/StudentEditPassword.vue";
import DeleteIcon from "@/components/svg/DeleteIcon.vue";
import EditIcon from "@/components/svg/EditIcon.vue";
import ExportIcon from "@/components/svg/ExportIcon.vue";
import LeftArrowIcon from "@/components/svg/LeftArrowIcon.vue";
import LockIcon from "@/components/svg/LockIcon.vue";
import ViewIcon from "@/components/svg/ViewIcon.vue";
import TeacherIcon from "@/components/svg/TeacherIcon.vue";
import HttpRda from "../../../http-rda";

export default {
  name: "alunos",
  components: {
    ViewIcon,
    EditIcon,
    ExportIcon,
    TeacherIcon,
    DeleteIcon,
    LeftArrowIcon,
    LockIcon,
    SelectClassrooms,
    SelectStudentsStatus,
    SelectCycles,
    StudentEditData,
    StudentEditPassword,
    SelectCalendar,
    SelectCycleSituation,
  },

  data() {
    return {
      showFloatingHeader: false,
      originalHeaderPosition: 0,
      descOrder: false,
      wasRequestMade: false,
      studentToEdit: {},
      studentToPassword: {},
      search: "",
      filter: null,
      cycle_select: null,
      cycle: null,
      calendar: null,
      classroom: null,
      is_active: true,
      cycle_situation: null,
      searchTerm: "",
      students: null,
      currentPage: 1,
      count: 0,
      perPage: 10,
      isLoadingStudentReport: false,
      breadcrumb: [
        {
          text: "Comunidade",
          href: "/comunidade",
        },
        {
          text: "Alunos",
          href: "/alunos",
          active: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      user: "auth/getAuthData",
    }),

    canEdit() {
      if (!this.user.role) return false;
      return ![
        "teacher",
        "student",
        "parent",
        "specialized_educational_support",
        "psychologist",
      ].includes(this.user.role[0]);
    },

    isSpecializedEducationalSupport() {
      if (!this.user.role) return false;
      return (
        this.user.role.includes("specialized_educational_support") ||
        this.user.role.includes("psychologist")
      );
    },

    isTeacher() {
      if (!this.user.role) return false;
      return this.user.role.includes("teacher");
    },
  },

  methods: {
    ...mapActions({
      getStudent: "community/getStudent",
      deleteStudent: "community/deleteStudent",
      updateStatusStudents: "community/updateStatusStudents",
    }),

    handleScroll() {
      const scrollY = window.scrollY;
      const PONTO_ATIVAR = 350;
      const PONTO_DESATIVAR = 340;

      if (scrollY >= PONTO_ATIVAR && !this.showFloatingHeader) {
        this.showFloatingHeader = true;
      } else if (scrollY <= PONTO_DESATIVAR && this.showFloatingHeader) {
        this.showFloatingHeader = false;
      }
    },

    setupScrollListener() {
      window.addEventListener("scroll", this.handleScroll);
    },

    removeScrollListener() {
      window.removeEventListener("scroll", this.handleScroll);
    },

    async downloadStudentReport(studentId = null, cycleId = null) {
      let url;
      const cycleIdAux = {};

      if (studentId) {
        url = `/students/data_report?id=${studentId}`;
        cycleIdAux.cycle = cycleId;
      } else {
        url = `/students/data_report`;
      }

      try {
        this.isLoadingStudentReport = true;
        const response = await HttpRda.get(url, {
          params: {...this.filter, ...cycleIdAux},
          responseType: "blob",
        });

        const newBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        const date = new Date().toLocaleString("pt-BR").replace(/[/:, ]/g, "-");

        let data = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = data;
        link.download = `Relatorio_de_dados_de_matricula_${date}`;
        link.click();

        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100);

        const Toast = this.$swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: `Relatório exportado com sucesso!`,
        });
        this.isLoadingStudentReport = false;

        return response;
      } catch (error) {
        this.isLoadingStudentReport = false;

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possivel exportar o relatório!",
          footer: "Por favor, tente novamente mais tarde.",
        });

        return error;
      }
    },

    callbackCycles({id}) {
      this.cycle = id !== -1 ? id : null;
      this.cycle_select = id;
      this.currentPage = 1;
      this.clearClassromms();
      this.listStudents();
    },

    callbackClassrooms({id}) {
      this.classroom = id !== -1 ? id : null;
      this.currentPage = 1;
      this.listStudents();
    },

    callbackStudentsStatus({id}) {
      this.is_active = id !== null ? id : null;
      this.currentPage = 1;
      this.listStudents();
    },

    callbackCycleSituation({value}) {
      this.cycle_situation = value !== null ? value : null;
      this.currentPage = 1;
      this.listStudents();
    },

    callbackCalendars({id}) {
      this.calendar = id !== -1 ? id : null;
      this.currentPage = 1;
      this.listStudents();
    },

    async listStudents(page = 1) {
      const params = {
        page,
        search: this.search,
        cycle: this.cycle,
        is_active: this.is_active,
        cycle_situation: this.cycle_situation,
        classroom: this.classroom,
        calendar: this.calendar,
      };

      Object.keys(params).forEach(
        (key) =>
          (params[key] == null || params[key] === "") && delete params[key],
      );

      this.$router.replace({
        query: params,
        limit: this.perPage,
      });

      this.filter = {...params};
      delete this.filter.limit;
      delete this.filter.page;

      await HttpRda.get("/students-community", {params})
        .then((res) => {
          this.students = res.data.students;
          this.count = res.data.count;
          this.wasRequestMade = true;
        })
        .catch(() => {});
    },

    async searchStudent() {
      if (!this.search) {
        this.clearFields();
        return;
      }
      this.currentPage = 1;
      this.listStudents();
    },

    clearFields() {
      this.search = "";
      this.clearCycles();
      this.is_active = true;
      this.cycle_situation = null;
      this.currentPage = 1;
      this.listStudents();
    },

    clearCycles() {
      this.cycle = null;
      this.cycle_select = null;
      this.currentPage = 1;
      this.clearClassromms();
      this.listStudents();
    },

    clearCalendar() {
      this.calendar = null;
      this.currentPage = 1;
      this.listStudents();
    },

    clearClassromms() {
      this.classroom = null;
      this.currentPage = 1;
      this.listStudents();
    },

    clearStudentsStatus() {
      this.is_active = null;
      this.currentPage = 1;
      this.listStudents();
    },

    clearCycleSituation() {
      this.cycle_situation = null;
      this.currentPage = 1;
      this.listStudents();
    },

    setStudent(student) {
      this.studentToEdit = student;
    },

    setStudentPassword(student) {
      this.studentToPassword = student;
    },

    updateStatus(id, status) {
      var data = {
        id: id,
        is_active: status,
      };
      DataService.update(id, data)
        .then((response) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "bottom-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: `Status atualizado com sucesso!`,
          });

          return response;
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel atualizar!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error;
        });
    },

    confirmStudentDeletion(id) {
      this.$swal
        .fire({
          title: "Tem certeza?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await this.deleteStudent(id);
              this.$swal
                .fire("Excluído!", "Aluno foi excluído.", "success")
                .then((response) => {
                  this.listStudents();
                  return response.data;
                });
            } catch (error) {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possivel excluir!",
                footer: "Por favor, tente novamente mais tarde.",
              });

              return error;
            }
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel excluir!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error;
        });
    },

    syncFilterssWithQuery() {
      const query = this.$route.query;

      this.calendar = query.calendar || null;
      this.cycle = query.cycle || null;
      this.classroom = query.classroom || null;
      this.is_active = query.is_active || null;
      this.cycle_situation = query.cycle_situation || null;
      this.search = query.search || "";
    },

    updateQuery() {
      const query = {
        calendar: this.calendar,
        cycle: this.cycle,
        classroom: this.classroom,
        is_active: this.is_active,
        cycle_situation: this.cycle_situation,
        search: this.search,
        page: 1,
      };

      Object.keys(query).forEach(
        (key) => (query[key] == null || query[key] === "") && delete query[key],
      );

      this.$router.replace({query});
    },
  },

  watch: {
    currentPage() {
      this.listStudents(this.currentPage);
      window.scrollTo({top: 0, behavior: "smooth"});
    },

    "$route.query": {
      handler(query) {
        this.isInitializing = true;
        this.calendar = query.calendar ? Number(query.calendar) : null;
        this.cycle = query.cycle ? Number(query.cycle) : null;
        this.classroom = query.classroom ? Number(query.classroom) : null;
        this.is_active =
          query.is_active === undefined ? null : query.is_active === "true";
        this.search = query.search || "";
        this.cycle_situation = query.cycle_situation || null;

        this.$nextTick(() => {
          this.isInitializing = false;
        });
      },
    },
  },

  async created() {
    const query = this.$route.query;

    this.perPage = Number(query.limit) || 10;
    this.search = query.search || "";
    this.cycle = query.cycle ? Number(query.cycle) : null;
    this.cycle_select = query.cycle ? Number(query.cycle) : null;
    this.is_active =
      query.is_active === undefined || query.is_active === null
        ? true
        : query.is_active === "true";
    this.classroom = query.classroom ? Number(query.classroom) : null;
    this.calendar = query.calendar ? Number(query.calendar) : null;
    this.cycle_situation = query.cycle_situation || null;
  },

  async mounted() {
    this.$nextTick(() => {
      this.setupScrollListener();
    });

    const page = Number(this.$route.query.page) || 1;
    this.currentPage = page;

    await this.listStudents(page);
  },

  beforeDestroy() {
    this.removeScrollListener();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.title {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .tags_count {
    background-color: #68c5b7;
    font-size: 18px;
    border-radius: 3px;
    color: #fff;
    margin-left: 10px;
    padding: 3px 10px;
    height: max-content;
  }
}

.list-top {
  margin-top: 30px;
  margin-bottom: 30px;
}

.list-teacher {
  background-color: $white;
  border: 1px solid $grey5;
  border-radius: 10px;
  margin-bottom: 15px;
  min-height: 80px;
  margin-left: 0 !important;
  margin-right: 0 !important;

  &:hover {
    border-color: transparent;
    background-image: linear-gradient($white, $white),
      radial-gradient(circle at top left, $orange, $purple);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }

  p {
    margin: 0;
  }

  .disciplines {
    .name {
      display: inline-block;
      line-height: 22px;
      .comma {
        margin-right: 4px;
      }

      &:last-child {
        .comma {
          display: none;
        }
      }
    }
  }

  .cycles {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .tags {
      background-color: $blue;
      border-radius: 5px;
      color: $white;
      font-weight: $bold;
      line-height: 28px;
      margin: 3px auto;
      padding: 0 3px;
      text-align: center;
      vertical-align: middle;
    }
  }
}

.outline {
  color: #fff !important;
  background: transparent;
  max-width: 220px !important;
  margin-right: 20px;

  &:hover {
    color: #68c5b7 !important;
  }
}

.header-list-teacher {
  margin-top: 20px;

  p {
    width: 100% !important;
    white-space: normal !important;
    margin: 0;
  }

  @media (max-width: 1300px) {
    max-width: 1200px;

    p {
      font-size: 12px;
    }
  }

  &.floating-header {
    position: sticky;
    top: 20px;
    transform: translateX(-50%);
    z-index: 1000;
    background-color: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
    border-radius: 15px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    width: 100%;
    padding: 5px 0px;
    align-items: center;

    @media (max-width: 1300px) {
      max-width: 1200px;
    }

    opacity: 0;
    animation: fadeInDown 0.4s ease forwards;
  }
}

.student-status-switch {
  display: inline-block;
  transform: translateX(-12px);
}

.text-center {
  text-align: center !important;
}

.text-left {
  text-align: left !important;
}
</style>
